import { environment } from '../../../../environments/environment';


export const VersionSettings = {



     get versionNumber(): string { return (environment as any).version || 'local-dev'; },


     get isProduction(): boolean { return environment.production; },
     get isSaasMode(): boolean { return environment.saasMode; }
};
